function Footer() {
  return (
    <footer className="mt-auto py-5 bg-dark">
      <div className="container d-flex justify-content-center">
        <span className="text-muted">© 2022 golanfoods.com-. All rights reserved.</span>
      </div>
    </footer>
  );
}

export default Footer;
